import MindsetsJsSDK from "../../index";

export const LOADING = '[Global] Loading';
export const LOADED_ME = '[Global] Loaded Me';
export const AUTH_CODE_ISSUED = '[Login] Auth Code Issued';

const fetchMe = () => {
    return dispatch => {
        return MindsetsJsSDK().Api.user
            .me.get()
            .then(response => {
                dispatch(LoadedMeAction(response.user));
            });
    }
};
export const LoadMeAction = () => dispatch => dispatch(fetchMe());

export const LoadedMeAction = payload => {
    return {
        type: LOADED_ME,
        payload
    }
};

export const LoadingAction = (payload, content = null) => {
    return {
        type: LOADING,
        payload,
        content
    }
};

export const LoggedInAction = () => () => {
    window.location.href = '/';

    return null;
};

export const AuthCodeIssuedAction = payload => {
    return {
        type: AUTH_CODE_ISSUED,
        payload
    }
};
